export default "__VITE_ASSET__DWrla__1__"